define.alias("ember-math-helpers/helpers/tanh", "media/helpers/tanh");